import { render, staticRenderFns } from "./PersonTransactionProfileHeader.vue?vue&type=template&id=03f26473&scoped=true&"
import script from "./PersonTransactionProfileHeader.vue?vue&type=script&lang=js&"
export * from "./PersonTransactionProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonTransactionProfileHeader.vue?vue&type=style&index=0&id=03f26473&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f26473",
  null
  
)

export default component.exports